<div class="vh-100 vw-100 d-flex flex-column page">
  <div class="content-wrapper">
    <app-navbar [showLogo]="false"></app-navbar>
  </div>

  <div class="background-image flex-grow-1 d-flex flex-column justify-content-center align-items-center">
    <div>
      <div class="disclaimer">
        <div class="disclaimer-content-grid">
          <ix-icon name="legal" size="32" class="disclaimer-content-column-left"></ix-icon>
          <ix-typography format="label" bold="true" class="disclaimer-content-row-top">
            {{ 'disclaimer.title' | translate }}
          </ix-typography>
          <ix-typography format="body" class="disclaimer-content-row-mid">
            {{ 'disclaimer.content' | translate }}
          </ix-typography>
          <div class="disclaimer-content-row-bottom">
            <ix-button class="me-2" (click)="onDisclaimerDeclined()" onkeypress="" variant="secondary">
              {{ 'disclaimer.decline_text' | translate }}
            </ix-button>
            <ix-button (click)="onDisclaimerAccepted()" onkeypress="" [loading]="loading" variant="primary">
              {{ 'disclaimer.accept_text' | translate }}
            </ix-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dynamic-footer
    [links]="[
      { text: 'links.siemens_battery_passport_text', href: 'links.siemens_battery_passport_link' },
      { text: 'links.si_green_text', href: 'links.si_green_link' },
      { text: 'links.battery_pass_eu_text', href: 'links.battery_pass_eu_link' },
      { text: 'links.catena_x_text', href: 'links.catena_x_link' }
    ]"
  ></app-dynamic-footer>
</div>
